import { createSlice, PayloadAction, createSelector } from "@reduxjs/toolkit";

export interface IToastType {
  message: string | null;
  type: string | null;
}

const initialState: IToastType = {
  message: null,
  type: null,
};

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    ToastShow: (state: IToastType, action: PayloadAction<IToastType>) => {
      state.message = action.payload.message;
      state.type = action.payload.type;
    },
  },
});

// Define a simple selector to get the toast state
const selectToastState = (state: { toast: IToastType }) => state.toast;

// Memoized selector
export const toastSelector = createSelector(
  [selectToastState],
  (toast) => ({
    message: toast.message,
    type: toast.type,
  })
);

const { actions, reducer } = toastSlice;

export const { ToastShow } = actions;

export default reducer;